import { ApiService } from '../../root-services/api.service';
import { TimezoneService } from './../../shared/services/timezones.service';
import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { EditionService } from './../../shared/services/edition.service';
import { EditionListService } from '../../editions/edition.service';
import { ErrorService } from './../../shared/services/error.service';
import { CurrentUserService } from './../../shared/services/current-user.service';
import { EditionSettings } from './../../models/global/edition-settings';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { PermissionsService } from '../../shared/services/permissions.service';
import { SomePermissions } from '../../models/permissions';

@Component({
  selector: 'app-edition-settings',
  templateUrl: './edition-settings.component.html',
  styleUrls: ['./edition-settings.component.less']
})

export class EditionSettingsComponent implements OnInit, OnDestroy {
  @ViewChild('form') form: ElementRef;

  public settings: EditionSettings;
  public editionForm: FormGroup;
  public darkText: boolean;
  public expiry: string;
  public saving: boolean;
  public saved: boolean;
  public errors: string[];
  public hasNomadicAdministration: Observable<boolean>;
  public tab = 'general';

  private showPreview = false;
  public previewOpen = false;
  private subs: Subscription[] = [];

  constructor(
    private editionList: EditionListService,
    private editionService: EditionService,
    private _fb: FormBuilder,
    private api: ApiService,
    private route: ActivatedRoute,
    public tz: TimezoneService,
    private errorService: ErrorService,
    private permissionsService: PermissionsService,
    private currentUserService: CurrentUserService
  ) { }

  public ngOnInit(): void {
    let editionId = this.editionList.getEdition().id;
    this.subs.push(this.route.data.subscribe(data => this.tab = data.settings));
    this.subs.push(this.editionList.waitForEdition().subscribe(() => {
      this.getSettings();
      this.currentUserService.refreshUserData()
    }));
    this.hasNomadicAdministration = this.permissionsService
            .checkPermission('nomadicAdministration')
  }

  public ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }
  /**
   * Public Methods
   */

  public expires(date: string): void {
    const expiry = `${date}T00:00:00Z`;
    const control: FormControl = <FormControl>this.editionForm.controls['expires'];
    control.setValue(expiry);
  }

  public bannerText(dark: boolean): void {
    const control: FormControl = <FormControl>this.editionForm.controls['dark_text'];
    if (dark) {
      this.darkText = true;
      control.patchValue(true);
    }
    if (!dark) {
      this.darkText = false;
      control.patchValue(false);
    }
  }

  public setContent(content: string, field: string): void {
    const control: FormControl = <FormControl>this.editionForm.controls[field];
    control.markAsDirty();
    control.setValue(content);
  }

  public save(body: any, isValid: boolean): void {
    console.log(body);
    this.saving = true;
    this.saved = false;
    this.editionService.editEdition(body)
                       .subscribe(() => {
                         this.saving = false;
                         this.saved = true;
                         this.getSettings();
                         if (this.showPreview) {
                           this.previewOpen = true;
                           this.showPreview = false;
                         }
                         this.errors = null;
                       }, error => {
                         this.saving = false;
                         this.errors = this.errorService.messages(error);
                       });
  }

  /**
   * Private Methods
   */

  private getSettings(): void {
    this.editionService.getEdition()
      .subscribe(edition => {
        this.settings = edition;
        this.editionForm = this.buildForm();
        this.setCustomData();
        this.editionForm.patchValue(edition);
        console.log(this.settings);
        console.log('editionForm value:', this.editionForm.value);
      });
  }

  private buildForm(): FormGroup {
    return this._fb.group({
      name: [''],
      internal_name: [null],
      timezone: [''],
      expires: [''],
      licenses: [''],
      welcome_title: [''],
      welcome_message: [''],
      welcome_image: [''],
      welcome_image_caption: [''],
      welcome_postscript: [''],
      banner_image: [''],
      dark_text: [false],
      intro_video_ref: [''],
      about_content: [''],
      program_share_message: [''],
      logo_image: [''],
      email_header_image: [''],
      primary_color: [''],
      enable_community: [false],
      community_terms_popup: [''],
      community_terms_page: [''],
      email_notification_sender_address: [''],
      email_notification_sender_name: [''],
      segregate_discussions: [false],
      enable_home_page: [false],
      show_resources_on_home: [false],
      show_programs_on_home: [false],
      show_journeys_on_home: [false],
      show_elective_journeys_on_home: [false],
      show_discover_programs_on_home: [false],
      show_community_on_home: [false],
      show_welcome_on_home: [false],
      keep_welcome_on_home: [false],
    });
  }

  private saveImage(controlName: string, key: string) {
    let ctrl: FormControl = (<any>this.editionForm).controls[controlName];
    ctrl.markAsDirty();
    ctrl.setValue(key);
  }

  private setCustomData(): void {
    if (this.settings.dark_text) {
      this.darkText = true;
    }
    if (!this.settings.dark_text) {
      this.darkText = false;
    }
    if (this.settings.expires) {
      this.expiry = new Date(this.settings.expires).toISOString().substring(0, 10);
    }
  }

  private saveAndPreview(): void {
    this.showPreview = true;
    this.form.nativeElement.dispatchEvent(new Event('submit'));
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-settings/edition-settings/edition-settings.component.ts